import React from 'react'

export const DisenoWebPalermo = () => {
    return (
        <main className="margen1 bg-[#EEF2FF] dark:bg-[#050817]">
            {/* Título principal con keyword exacta */}
            <section className="mb-3">
                <h1 className="titulo1 text-center mb-[3rem]">
                    Elite Web Design & Development in Exton | Power Bit
                </h1>
                <p className="!font-medium !leading-5">
                    Power Bit specializes in  <strong>premium web design in Exton, PA,</strong> for professionals, established brands, and entrepreneurs who demand a standout online presence. We build fast, secure, and bespoke websites engineered for high-end conversion and local market dominance.
                </p>
            </section>

            {/* Servicios con keyword en subtítulo */}
            <section className="mb-3">
                <h2 className="lg:text-3xl text-xl font-bold mb-3">
                    Our Web Design Solutions in Exton, PA
                </h2>
                <ul className="!font-medium !leading-5 list-disc list-inside">
                    <li>
                        <strong>Custom web development</strong> for Exton businesses, focused heavily on user experience (UX) and lead generation.
                    </li>
                    <li>
                        <strong>Targeted digital advertising</strong> to amplify your new platform across search engines and premium social networks.
                    </li>
                    <li>
                        <strong>Strategic marketing frameworks</strong> to rank your brand at the top of the Exton and Greater Philadelphia markets.
                    </li>
                </ul>
            </section>

            {/* Identidad local reforzada */}
            <section className="mb-3">
                <h2 className="lg:text-3xl text-xl font-bold mb-3">
                    The Premier Web Design Agency in Chester County
                </h2>
                <p className="!font-medium !leading-5">
                    Based in Exton, we are a digital agency specialized in <strong>crafting web experiences</strong> that deeply connect with your target demographic. We know what it takes to thrive in this corporate landscape and provide digital assets that perform. If you value proximity, elite professionalism, and tangible outcomes, you have found your team.
                </p>
            </section>

            {/* CTA con enlaces en lista tabulada */}
            <section className="mb-3">
                <h2 className="lg:text-3xl text-xl font-bold mb-3">
                    Want to Accelerate Your Digital Growth?
                </h2>
                <p className="!font-medium !leading-5 mb-5">
                    At Power Bit, we translate your business goals into premium digital assets. Choose your next step:
                </p>
                <ul className="list-disc list-inside pl-4 !font-medium !leading-5">
                    <li>
                        <a
                            href="/#contact"
                            className="underline font-semibold underline-offset-4 dark:font-medium decoration-[#274dd8] dark:hover:decoration-[#fff] hover:decoration-[#000] text-white-600"
                        >
                            Contact an Advisor
                        </a>
                    </li>
                    <li>
                        <a
                            href="/#services"
                            className="underline font-semibold underline-offset-4 dark:font-medium decoration-[#274dd8] dark:hover:decoration-[#fff] hover:decoration-[#000] text-white-600"
                        >
                            Explore Services
                        </a>
                    </li>
                    <li>
                        <a
                            href="/#portfolio"
                            className="underline font-semibold underline-offset-4 dark:font-medium decoration-[#274dd8] dark:hover:decoration-[#fff] hover:decoration-[#000] text-white-600"
                        >
                            Our Work
                        </a>
                    </li>
                </ul>
            </section>
        </main>
    )
}